export const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const INTERNATIONAL_PHONE = /^\d{10}$/;
export const E164_MOBILE_NUMBER_FORMAT = /^\+[1-9]\d{1,14}$/;
export const NUMBER = /^[0-9]+$/;
export const NO_ASTERISK_REGEX = /^[^*]*$/;
export const BSB_REGEX = /^\d{6}$/;

export const AUSTRALIAN_DRIVERS_LICENSE_NUMBER = /^[A-Za-z0-9]*$/;
export const AUSTRALIAN_DRIVERS_LICENSE_CARD_NUMBER = /^[A-Za-z0-9]*$/;
export const AUSTRALIAN_PASSPORT_NUMBER = /^[A-Za-z]{1,2}[0-9]{7}$/;
export const MEDICARE_CARD_NUMBER = /^[0-9]{10}$/;
export const MEDICARE_INDIVIDUAL_NUMBER = /^[0-9]$/;
export const MEDICARE_NAME_LINE = /^[A-Za-z0-9\s\-"']*$/;
export const CENTRELINK_NAME = /^[A-Z a-z0-9\-']*$/;
export const CENTRELINK_CUSTOMER_REF_NUM = /^[0-9]{9}[A-Za-z]{1}$/;
export const NZ_PASSPORT_NUMBER = /^[A-Za-z]{1,2}[0-9]{6}$/;
export const NZ_DRIVERS_LICENSE_NUMBER = /^[A-Za-z]{2}[0-9]{6}$/;
export const NZ_DRIVERS_LICENSE_VERSION = /^[0-9]{3}$/;
